// Maria, 19 October 2026: a size watcher that changes the page straight away makes the browser report
// 'ResizeObserver loop completed with undelivered notifications', which the development build shows as an error
// screen. The change waits for the next frame instead, once per frame however many times it is asked for.
const onNextFrame = fn => {
    let frame = 0;
    return (...args) => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => fn(...args));
    };
};

export default onNextFrame;
